<template>
  <el-autocomplete
    v-model="val"
    :value-key="valueKey"
    :disabled="disabled"
    :placeholder="placeholder"
    :fetch-suggestions="querySearch"
    :style="{ width: width, verticalAlign: 'top' }"
  ></el-autocomplete>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    valueKey: String, // 建议的健名
    value: [String, Array, Number],
    placeholder: String,
    width: String,
    disabled: { type: Boolean, default: false },
    code: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      val: '',
      list: [],
    };
  },
  watch: {
    value() {
      this.val = this.value;
    },
    val() {
      this.$emit('input', this.val);
    },
  },
  mounted() {
    this.val = this.value;
    this.getSelectList();
  },
  methods: {
    // 字典转换
    transformDicCode(list) {
      if (!Array.isArray(list)) {
        return {};
      }
      const data = {};
      list.forEach((item) => {
        data[item.code] = item.value;
      });
      return data;
    },
    // 获取字典
    getSelectList: function () {
      if (this.code) {
        this.$getJSON(apis.DictionaryCode, { groupCodes: this.code }).then((res) => {
          const list = res.data[this.code];
          this.list = list;
          this.$emit('getList', list);
          this.$emit('getMap', this.transformDicCode(list));
        });
        return;
      }
      this.$getJSON(this.url, this.params).then((res) => {
        this.list = res.data;
        this.$emit('getList', res.data);
      });
    },
    // 本地检索
    querySearch(queryString, cb) {
      const results = queryString ? this.list.filter((t) => t[this.valueKey].toLowerCase().indexOf(queryString.toLowerCase()) === 0) : this.list;
      cb(results);
    },
  },
};
</script>
<style>
</style>
